import { render, staticRenderFns } from "./AddExpensesCenter.vue?vue&type=template&id=00c744f2&scoped=true"
import script from "./AddExpensesCenter.vue?vue&type=script&lang=js"
export * from "./AddExpensesCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c744f2",
  null
  
)

export default component.exports